import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormTable({ data = {} }) {
    const { rows = [], header = [] } = data;
    return /*#__PURE__*/ _jsxs("table", {
        style: styles.table,
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsx("tr", {
                    children: header.map((header, index)=>/*#__PURE__*/ _jsx("th", {
                            style: styles.th,
                            children: header
                        }, `header_index_${index}`))
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: rows.map((row, rowIndex)=>/*#__PURE__*/ _jsx("tr", {
                        children: row.map((item, columnIndex)=>/*#__PURE__*/ _jsx("td", {
                                style: styles.td,
                                colSpan: item.span,
                                children: item.element
                            }, `row_index_${rowIndex}_col_index_${columnIndex}`))
                    }, `row_index_${rowIndex}`))
            })
        ]
    });
}
const styles = {
    table: {
        display: "table",
        width: "100%",
        // border
        borderCollapse: "collapse",
        borderSpacing: "0px",
        border: "solid gray 1px",
        borderRadius: "4px",
        WebkitBorderRadius: "4px",
        MozBorderRadius: "4px",
        // font
        textAlign: "left",
        fontWeight: 400,
        fontSize: "0.9rem"
    },
    th: {
        padding: "4px",
        backgroundColor: "#e0e0e0",
        border: "solid gray 1px"
    },
    td: {
        border: "solid gray 1px",
        padding: "0 4px"
    },
    firstColumn: {
        borderLeft: "none"
    }
};
